import { deleteRequest, getFileRequest, getImageRequest, getRequest, postRequest, putRequest, RequestDataType } from "services/api"
import {
    CreateAssetSection,
    EditingAssetSectionWindow,
    LinerDrawingReference,
    PutAssetSectionImageDto,
    PutAssetSectionLinersDto,
    PutLinerRegion,
    WearReferencePlane,
} from "../models/asset-section-models"

export const postNewAssetSection = async (data: Partial<CreateAssetSection>) => await postRequest("/assetSections", data, RequestDataType.FormData)

export const deleteAssetSection = async (assetSectionId: string) => await deleteRequest("/assetsections", assetSectionId)

export const editAssetSection = async (data: Partial<EditingAssetSectionWindow>) => await putRequest("/assetSections", data, RequestDataType.FormData)

export const getAssetSectionSVG = async (assetSectionId: string) => await getImageRequest(`/assetSections/GetSVG${assetSectionId}`)

export const getAssetSectionPdf = async (assetSectionId: string) => await getFileRequest(`/assetSections/GetPdf${assetSectionId}`)

export const getAssetSectionLinersLocations = async (assetSectionId: string) => await getRequest(`/assetSections/GetLinersLocations${assetSectionId}`)

export const putAssetSectionLiners = async (data: PutAssetSectionLinersDto) =>
    await putRequest("/assetSections/putliners", data, RequestDataType.Entity)

export const putAssetSectionImage = async (data: PutAssetSectionImageDto) =>
    await putRequest("/assetSections/putAssetSectionImage", data, RequestDataType.FormData)

export const putLinerRegionsHoles = async (data: PutLinerRegion[]) => await putRequest("/assetSections/putlinersHoles", data, RequestDataType.Entity)

export const putlinersDrawingReferences = async (data: LinerDrawingReference[]) =>
    await putRequest("/assetSections/PutLinersDrawingReferences", data, RequestDataType.Entity)

export const putLinersLocationWearReferencePlan = async (data: WearReferencePlane[]) =>
    await putRequest("/assetSections/putLinersLocationWearReferencePlan", data, RequestDataType.Entity)

export const checkAssetSectionFilesExist = async (assetSectionId: string) =>
    await getRequest(`/assetSections/CheckAssetSectionFilesExist${assetSectionId}`)
